/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_APPLICATION: {
    size: 10,
    offset: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.profile',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_APPLICATION' },
      },
    },
    GET_APPLICATION: {
      invoke: {
        id: 'getApplication',
        src: 'getApplication',
        onDone: {
          target: 'RENDER_APPLICATION',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_APPLICATION_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_APPLICATION: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_APPLICATION',
        },
      },
    },
    RENDER_APPLICATION_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
